export class PlanOptionRuleTemplateTask {
    public planOptionRuleTemplateTaskId: number;
    public planOptionRuleId: number;
    public edhTemplateTaskId: number;
    public isAdd: boolean;
    public isRemove: boolean;
}